module.exports = __webpack_public_path__ + "img/white_navtop_back.f8a6de8d.png";